'use client'

import { UserRegistration } from '@/components/user-registration'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import type { ReactNode } from 'react'
import { AppKitProvider } from './AppKitProvider'
import { I18nProvider } from './I18nProvider'
import QueryProvider from './QueryProvider'
import TradingProvider from './TradingProvider'
import { WalletProvider } from './WalletProvider'

export default function Providers({ children }: { children: ReactNode }) {
	return (
		<I18nProvider>
			<NuqsAdapter>
				<QueryProvider>
					<AppKitProvider>
						<WalletProvider>
							<UserRegistration />
							<TradingProvider>{children}</TradingProvider>
						</WalletProvider>
					</AppKitProvider>
				</QueryProvider>
			</NuqsAdapter>
		</I18nProvider>
	)
}
